import { getBoxCenter } from './snapUtils';

export const ROTATION_SNAP_DEGREES = 5;

export const snapAngleToStep = (angle, step = ROTATION_SNAP_DEGREES) => {
    if (!Number.isFinite(angle) || !Number.isFinite(step) || step <= 0) return 0;
    return Math.round(angle / step) * step;
};

export const normalizeAngleDelta = (angle) => {
    if (!Number.isFinite(angle)) return 0;
    return ((angle + 180) % 360 + 360) % 360 - 180;
};

export const getSelectionCenter = (json, selectedIds) => {
    const centers = (selectedIds || [])
        .map(id => json?.[id]?.box)
        .filter(Boolean)
        .map(getBoxCenter);

    if (centers.length === 0) return null;

    return centers.reduce((acc, center) => ({
        x: acc.x + center.x / centers.length,
        y: acc.y + center.y / centers.length
    }), { x: 0, y: 0 });
};

export const rotateBoxAroundPoint = (box, angle, center) => {
    if (!box?.transform || !center) return box;

    const rads = angle * Math.PI / 180;
    const cos = Math.cos(rads);
    const sin = Math.sin(rads);
    const [a, b, c, d] = box.transform;
    const halfW = (box.width || 0) / 2;
    const halfH = (box.height || 0) / 2;
    const boxCenter = getBoxCenter(box);

    const dx = boxCenter.x - center.x;
    const dy = boxCenter.y - center.y;
    const newCenterX = center.x + dx * cos - dy * sin;
    const newCenterY = center.y + dx * sin + dy * cos;

    const na = a * cos - b * sin;
    const nb = a * sin + b * cos;
    const nc = c * cos - d * sin;
    const nd = c * sin + d * cos;
    const ne = newCenterX - (na * halfW + nc * halfH);
    const nf = newCenterY - (nb * halfW + nd * halfH);

    return {
        ...box,
        transform: [na, nb, nc, nd, ne, nf]
    };
};

export const rotateSelection = (json, selectedIds, angle, center = getSelectionCenter(json, selectedIds)) => {
    if (!json || !center || !selectedIds || selectedIds.length === 0) return json;

    const rotatedJson = { ...json };

    selectedIds.forEach(id => {
        const item = json[id];
        if (!item?.box) return;

        rotatedJson[id] = {
            ...item,
            box: rotateBoxAroundPoint(item.box, angle, center)
        };
    });

    return rotatedJson;
};
